import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from '@app/core/services/utils.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import * as _ from 'lodash';

@Component({
  selector: 'app-element-type-date',
  templateUrl: './element-type-date.component.html',
  styleUrls: ['./element-type-date.component.scss']
})
export class ElementTypeDateComponent implements OnInit {

  @Input() compiling?: boolean;
  @Input() viewMode: boolean;
  @Input() elementFg?: FormGroup;

  @Output() valueUpdate = new EventEmitter<FormGroup>();

  formGroup: FormGroup;
  mandatory: boolean;
  defaultFormat: string;
  
  today = new Date();
  bsConfig: Partial<BsDatepickerConfig> = {
    containerClass: 'theme-red'
  };

  constructor(
    public utils: UtilsService,
    private formBuilder: FormBuilder
  ) {
    this.formGroup = this.formBuilder.group({
      name: ['', Validators.required],
      label: ['', Validators.required],
      order: [0, [Validators.required, Validators.min(0), Validators.max(100)]],
      format: ['DD/MM/YYYY', Validators.required],
      defaultFormat: ['SYSDATE', Validators.required],
      mandatory: [false, Validators.required],
      searchable: [false, Validators.required],
      key: [false, Validators.required]
    });
  }

  ngOnInit(): void {
    /** FormGroup values are set on view / edit, since element values are already defined */
    if (this.elementFg) {
      this.formGroup = this.elementFg;

      // Property added to the form when the element is used as input on instance creation
      if (this.compiling) {
        this.mandatory = this.formGroup.get('mandatory').value;
        this.defaultFormat = this.formGroup.get('format').value;

        this.formGroup.addControl('compiling', this.formBuilder.group({
          name: [this.formGroup.get('name').value, Validators.required],
          inputValue: ['', this.mandatory ? Validators.required : null]
        }));

        this.bsConfig.dateInputFormat = this.defaultFormat ? this.defaultFormat : 'DD/MM/YYYY';
      }
    }
    
    this.valueUpdate.emit(this.formGroup);

    this.formGroup.valueChanges.subscribe(() => {
      this.valueUpdate.emit(this.formGroup);
    });
  }

}
